import { EInstitutionType } from '@ucheba/store/institutions/item/types'
import { UzSectionsEnum } from './types'

export const TYPE_NAMES = {
  [EInstitutionType.University]: 'вуза',
  [EInstitutionType.College]: 'колледжа',
  [EInstitutionType.School]: 'школы',
  [EInstitutionType.MBA]: 'МДА',
  [EInstitutionType.TrainingCenter]: 'учебного центра',
  [EInstitutionType.Kindergarten]: 'детского сада',
  [EInstitutionType.ForeignUniversity]: 'иностранного университета',
  [EInstitutionType.Agency]: 'агенства',
  [EInstitutionType.ChildrenCourses]: 'курсов для детей',
  [EInstitutionType.TrainingCourses]: 'обучающих курсов',
}

export interface IUzSectionsNavigationItem {
  name: string
  href: string
  key: string
}

export type TSectionsNavigation =
  | 'programs'
  | 'promotions'
  | 'opinions'
  | 'events'
  | 'news'
  | 'teachers'
  | 'articles'
  | 'comments'
  | 'olympiads'
  | 'units'
  | 'partners'

export const sectionsEventsNavigationItems: IUzSectionsNavigationItem[] = [
  {
    name: 'Основное',
    key: '',
    href: `/`,
  },
  {
    name: 'Программы',
    key: UzSectionsEnum.programs,
    href: `/${String(UzSectionsEnum.programs)}`,
  },
  {
    name: 'Подразделения',
    key: UzSectionsEnum.units,
    href: `/${String(UzSectionsEnum.units)}`,
  },
  {
    name: 'Отзывы',
    key: UzSectionsEnum.opinions,
    href: `/${String(UzSectionsEnum.opinions)}`,
  },
  {
    name: 'Карьера',
    key: UzSectionsEnum.career,
    href: `/${String(UzSectionsEnum.career)}`,
  },
  {
    name: 'Мероприятия',
    key: UzSectionsEnum.events,
    href: `/${String(UzSectionsEnum.events)}`,
  },
  {
    name: 'Олимпиады',
    key: UzSectionsEnum.olympiads,
    href: `/${String(UzSectionsEnum.olympiads)}`,
  },
  {
    name: 'Новости',
    key: UzSectionsEnum.news,
    href: `/${String(UzSectionsEnum.news)}`,
  },
  {
    name: 'Статьи',
    key: UzSectionsEnum.articles,
    href: `/${String(UzSectionsEnum.articles)}`,
  },
  {
    name: 'Вопросы',
    key: UzSectionsEnum.comments,
    href: `/${String(UzSectionsEnum.comments)}`,
  },

  // {
  //   name: 'Преподаватели',
  //   key: UzSectionsEnum.teachers,
  //   href: `/${String(UzSectionsEnum.teachers)}`,
  // },
  {
    name: 'Контакты',
    key: UzSectionsEnum.contacts,
    href: `/${String(UzSectionsEnum.contacts)}`,
  },
]

// Высота конентной части карточки если она пустая или имеет пару элементов в списке
export const PAGE_CONTENT_HEIGHT = 900
